import { render, staticRenderFns } from "./ChangeAddressPreview.vue?vue&type=template&id=b704bb14"
import script from "./ChangeAddressPreview.vue?vue&type=script&lang=js"
export * from "./ChangeAddressPreview.vue?vue&type=script&lang=js"
import style0 from "./ChangeAddressPreview.vue?vue&type=style&index=0&id=b704bb14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports